import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { ApiParameter } from "@insite/client-framework/Services/ApiService";
import { changeCustomerService } from "@WhiteCap/Services/ChangeCustomerService";
import { CustomApiHandler } from "@WhiteCap/Store/CustomHandlerCreator/CustomHandlerCreator";

export interface ChangeCustomerApiParameter extends ApiParameter {
    customerNumber: string;
    onError?: (error: string) => void;
    onSuccess?: () => void;
}

type HandlerType = CustomApiHandler<ChangeCustomerApiParameter, any>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = { ...props.parameter };
};

export const MakeApiRequest: HandlerType = async props => {
    const result = await changeCustomerService(
        props.apiParameter.customerNumber,
    );
    
    if (result.successful && props.apiParameter?.onSuccess) {
        props.apiParameter?.onSuccess();
  
    } else {
        if (props.apiParameter?.onError) {
            props.apiParameter.onError(result.errorMessage);
        }
        return false;
    }
};

export const chain = [PopulateApiParameter, MakeApiRequest];

const changeCustomer = createHandlerChainRunner(chain, "ChangeCustomer");
export default changeCustomer;
